import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
@Injectable()
export class ContextMenuService {
  private contextMenuClickSource = new Subject<any>();
  currentcontextMenuClick$ = this.contextMenuClickSource.asObservable();
  constructor() {}

  changeMessage(message: any) {
    this.contextMenuClickSource.next(message);
  }
}
